<ng-template [ngIf]="view === 'communityPage'">
  <ion-card *ngIf="bootcamp" class="bootcamp-card" style="overflow: inherit;">
    <a routerDirection="root" [routerLink]="'/bootcamp-overview/' + bootcamp.friendlyid">
      <ion-card-header class="card-header {{bootcamp.name}}">
        <ion-card-title class="card-title">{{bootcamp.title}}</ion-card-title>
        <ion-card-subtitle class="card-meta">
          <ng-container *ngIf="community && community.state === 'PA'">
            Cost {{(bootcamp.cost.regular / bootcamp.cost.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}}
          </ng-container>
          <ng-container *ngIf="!community || (community && community.state !== 'PA')">
            <ng-container *ngIf="community && !community.nucampFlex">
              Tuition {{(bootcamp.cost.earlybird / bootcamp.cost.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}}
            </ng-container>
            <ng-container *ngIf="community && community.nucampFlex">
              Tuition {{(bootcamp.costFlex.earlybird / bootcamp.costFlex.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}} / month
            </ng-container>
          </ng-container>
          <ng-container *ngIf="community && community.id === 'ICAN'"> USD </ng-container>
          <ng-container *ngIf="bootcamp.cost.tuitionmonths > 1 && !community?.nucampFlex">
             x {{bootcamp.cost.tuitionmonths}} payments
          </ng-container>
          <p *ngIf="(community && !community.international) || !community" style="font-size: x-small; font-weight: 300; padding-top: 2px">{{bootcamp.financingText.replace("/m", "/month")}}
          </p>
        </ion-card-subtitle>
      </ion-card-header>
    </a>
    <ion-card-content class="card-content">
      <a routerDirection="root" [routerLink]="'/bootcamp-overview/' + bootcamp.friendlyid">
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" class="ion-text-center course-graphic">
            <img [src]="'/assets/imgs/bootcamps/' + bootcamp.name.toLowerCase() + '.svg'" max-width="100%" [alt]="bootcamp.pagecontent.alt ? bootcamp.pagecontent.alt : bootcamp.title">
          </ion-col>
          <ion-col size="12" class="ion-text-center bootcamp-description">
            <p>{{bootcamp.description}}</p>
          </ion-col>
          <ion-col size="12" class="ion-text-center bootcamp-button">
            <ion-button [color]="'nucamp-' + bootcamp.name.toLowerCase()" data-cy="viewbootcamp">View bootcamp details</ion-button>
          </ion-col>
        </ion-row>
      </a>
    </ion-card-content>
    <ion-card-content *ngIf="showSchedule" class="ion-no-padding card-content-deliveries">
      <ion-row>
        <ion-col *ngIf="!bootcamp?.bootcampdeliveries" size="12" class="ion-text-center">
          <ng-container *ngFor="let i of [1,2,3,4]">
            <div class="ph-item" style="margin-bottom: 5px">
              <div class="ph-col-12">
                  <div class="ph-row">
                      <div class="ph-col-6 big"></div>
                      <div class="ph-col-6 empty"></div>
                      <div class="ph-col-4"></div>
                      <div class="ph-col-4 empty"></div>
                      <div class="ph-col-4"></div>
                      <div class="ph-col-2 empty big"></div>
                      <div class="ph-col-4 big"></div>
                      <div class="ph-col-4 big"></div>
                      <div class="ph-col-2 empty big"></div>
                  </div>
              </div>
          </div>
          </ng-container>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="bootcamp.bootcampdeliveries" class="course-schedule">
        <ion-col size="12" *ngFor="let bootcampdelivery of bootcamp.bootcampdeliveries.slice(0,4)" class="row ion-text-left">
          <ng-container *ngIf="bootcampdelivery">
            <span class="HH"><a href="/bootcampdetails/{{bootcampdelivery.id}}">Learn to code {{bootcampdelivery.title}} in {{bootcampdelivery.community.community.displayName}}, {{bootcampdelivery.community.community.state}} starting {{bootcampdelivery.startdate | nucampdate:'MMMM Do YYYY'}}</a></span>
            <div class="course-title hover" (click)="goToBootcampDetails(bootcampdelivery.id)">
              {{bootcampdelivery.startdate | nucampdate:'MMMM Do'}}&nbsp;
              <ng-container *ngIf="bootcampdelivery.privatedelivery">
                <ion-badge color="nucamp-dark" tooltip="{{bootcampdelivery.privatedelivery.description}}" theme="light" displayTouchscreen="true">{{bootcampdelivery.privatedelivery.label}}</ion-badge>
              </ng-container>
            </div>
            <ion-row class="course-meta" *ngIf="!bootcampdelivery.privatedelivery">
              <ion-col size="5.5" class="ion-text-left">Live online</ion-col>
              <ion-col size="6.5" class="ion-text-right hover">
                <div style="display: inline-flex; align-items: center;">
                  <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="people"></ion-icon>
                  <span *ngIf="bootcampdelivery.spotsleft <= 0"> Bootcamp Full</span>
                  <span *ngIf="bootcampdelivery.spotsleft > 3 && bootcampdelivery.spotsleft <= 6">
                    <b> {{bootcampdelivery.spotsleft}}</b> seat<ng-container *ngIf="bootcampdelivery.spotsleft > 1">s</ng-container> left
                  </span>
                  <span *ngIf="bootcampdelivery.spotsleft > 6 && bootcampdelivery.nFollowers > 0"><b> {{bootcampdelivery.nFollowers}}</b> Interested</span>
                  <span *ngIf="nStudentRegistered(bootcampdelivery.students) < 6 && bootcampdelivery.nFollowers === 0" (click)="followBootcamp(bootcampdelivery.id)" class="href"> Interested?</span>
                  <span *ngIf="bootcampdelivery.spotsleft <= 3 && bootcampdelivery.spotsleft > 0"><b> {{bootcampdelivery.spotsleft}}</b> seat<ng-container *ngIf="bootcampdelivery.spotsleft > 1">s</ng-container> left!</span>
                </div>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="bootcampdelivery.spotsleft <= 0">
              <ion-col size="12" class="ion-text-center bootcamp-button-padding button-register-interested">
                <ion-button size="small" fill="outline" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="fullbootcamp" (click)="goToBootcampDetails(bootcampdelivery.id)">Bootcamp Full</ion-button>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="bootcampdelivery.spotsleft > 0">
              <ion-col size="6" size-lg="7" size-xl="7" class="ion-text-right bootcamp-button-padding button-square-right button-register-interested">
                <ion-button size="small" fill="solid" [disabled]="bootcampdelivery.privatedelivery" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="interestedbootcamp" (click)="followBootcamp(bootcampdelivery.id)"><ion-icon name="thumbs-up-sharp"></ion-icon>&nbsp;I'm Interested</ion-button>
              </ion-col>
              <ion-col size="6" size-lg="5" size-xl="5" class="bootcamp-button-padding button-square-left button-register-interested align-correctly">
                <ion-button size="small" fill="solid" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="registerbootcamp" (click)="goToBootcampDetails(bootcampdelivery.id)"><ion-icon name="add-outline"></ion-icon>&nbsp;Register</ion-button>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ng-template>

<ng-template [ngIf]="view === 'bootcampDetailsPage'">
  <ion-card *ngIf="bootcamp" [ngClass]="completeBootcampOptions ? 'bootcamp-card3' : 'bootcamp-card2'">
      <ion-card-header *ngIf="community" class="card-header {{bootcamp.name}}" style="height: unset;">
        <ion-card-title class="card-title">
          <ion-row class="ion-justify-content-between">
            <ion-col size="12" size-md="auto" class="ion-padding-end" *ngIf="!startEndBootcamps">
              {{community.displayName}}<ng-container *ngIf="!community.international">, {{community.statelong}}</ng-container>
            </ion-col>
            <ion-col size="12" size-md="auto" class="ion-padding-end" *ngIf="startEndBootcamps">
              {{startEndBootcamps.dates}}
            </ion-col>
            <ion-col size="12" size-md="auto ion-text-left">
              <span class="card-inline-subtitle">
                Not near <b>{{community.displayName}}</b>? <span class="whitehref" (click)="requestCommunity()">Select your community</span>
              </span>
            </ion-col>
            <ion-col *ngIf="completeBootcampOptions && startEndBootcamps" size="12" size-md="auto ion-text-right">
              <ion-col size="12" class="ion-text-left">
                <div class="complete-button-padding">
                  <span class="bootcamp-button-padding button-square-right button-register-interested2" [ngClass]="{'button-register-interested3': completeBootcampOptions}">
                    <ion-button size="small" fill="solid" color="light"  data-cy="interestedbootcamp" (click)="followCBootcamp()"><ion-icon name="thumbs-up-sharp"></ion-icon>&nbsp;I'm Interested</ion-button>
                  </span>
                  <span class="bootcamp-button-padding button-square-left button-register-interested2" [ngClass]="{'button-register-interested3': completeBootcampOptions}">
                    <ion-button size="small" fill="solid" color="light"  data-cy="registerbootcamp" (click)="goToCompleteBootcampDetails(startEndBootcamps.startBootcampId)"><ion-icon name="add-outline"></ion-icon>&nbsp;Register</ion-button>
                  </span>
                </div>
              </ion-col>
            </ion-col>
          </ion-row>
        </ion-card-title>
      </ion-card-header>
    <ion-card-content *ngIf="showSchedule" class="ion-no-padding">
      <ion-row class="ion-no-padding">
        <ion-col *ngIf="community" size="12" class="cohort-community-image">
          <div class="image-attribution" *ngIf="community && community.img && community.img.meta" [innerHTML]="community.img.meta"></div>
          <img [src]="getCommunityImage(community).bootcampdetails" [alt]="'Picture of ' + community.displayName + ', ' + community.statelong" />
        </ion-col>
      </ion-row>
      <ion-row class="ion-padding" *ngIf="!community">
        <ion-col size="12" class="ion-padding ion-text-center cohort-no-community" (click)="requestCommunity()">
          <span [ngClass]="bootcamp.name + 'Font hover'" style="border-bottom: 2px dashed">Select Your Community</span>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="!bootcamp.bootcampdeliveries">
        <ion-col size="12" class="ion-text-center ion-padding">
          <ng-container *ngFor="let i of [1]">
              <div class="ph-item">
                <div class="ph-col-12">
                    <div class="ph-picture"></div>
                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                    </div>
                </div>
            </div>
          </ng-container>
        </ion-col>
      </ion-row>
      <ion-row class="ion-no-padding bootcampCard">
        <ion-col size="12" class="ion-no-padding" *ngIf="community">
          <ion-slides pager="true" [options]="bootcampDeliveriesOptions" 
            class="bootcamp-delivery-slide" id="bootcampSlider" #bootcampSlider
              style="--bullet-background: var(--ion-color-nucamp-{{bootcamp.name.toLowerCase()}}); --bullet-background-active: var(--ion-color-nucamp-{{bootcamp.name.toLowerCase()}});"
              (ionSlideDidChange)="ionSlideDidChange()">
            <ion-slide *ngFor="let bootcampdelivery of bootcamp.bootcampdeliveries">
              <ion-row class="ion-padding" *ngIf="bootcampdelivery">
                <span style="display:none"><a href="/bootcampdetails/{{bootcampdelivery.id}}">{{bootcampdelivery.title}} in {{bootcampdelivery.community.community.displayName}}, {{bootcampdelivery.community.community.state}}</a></span>
                <ion-col size="12" style="display: flex;" class="ion-text-left ion-align-items-center">
                  <span *ngIf="community" class="course-title" style="display: contents">
                    <ng-container *ngIf="!completeBootcampOptions">
                      {{bootcampdelivery.startdate | nucampdate:'MMMM Do'}}&nbsp;
                    </ng-container>
                    <ng-container *ngIf="completeBootcampOptions">
                      <ion-item mode="md" style="--background:none"lines="none" class="complete-thumbnail ion-no-padding">
                        <ion-thumbnail slot="start" class="ion-no-margin ion-padding-end">
                          <img [src]="'/assets/imgs/bootcamps/' + bootcampdelivery.name.toLowerCase() + '.svg'" [alt]="bootcampdelivery.title">
                        </ion-thumbnail>
                        <ion-label class="ion-text-wrap ion-no-margin">{{bootcampdelivery.title}}</ion-label>
                      </ion-item>
                    </ng-container>
                    <ng-container *ngIf="bootcampdelivery.privatedelivery">
                      <ion-badge color="nucamp-dark" tooltip="{{bootcampdelivery.privatedelivery.description}}" theme="light" displayTouchscreen="true">{{bootcampdelivery.privatedelivery.label}}</ion-badge>
                    </ng-container>
                  </span>
                  <span *ngIf="!community && !completeBootcampOptions" class="course-title">{{bootcampdelivery.community.community.displayName}}, {{bootcampdelivery.community.community.state}} - {{bootcampdelivery.startdate | nucampdate:'MMMM'}}</span>
                  <!-- <ion-badge [color]="'nucamp-' + bootcamp.name.toLowerCase()">live online</ion-badge> -->
                </ion-col>
                <ion-col size="12" style="display: grid; margin-top: unset;" class="ion-text-left course-meta">
                  <ng-container *ngIf="bootcampdelivery.community.community.state !== 'PA'">
                    <div class="course-meta-items">
                      <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="card-outline"></ion-icon>
                      <span>
                        <ng-container *ngIf="!bootcampdelivery.nucampFlex">
                          {{bootcampdelivery.cost.tuitionmonths}} payments of
                        </ng-container>
                        <b>{{(bootcampdelivery.cost.earlybird / bootcampdelivery.cost.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}}<ng-container *ngIf="bootcampdelivery.cost.tuitionmonths > 1">
                            <ng-container *ngIf="community && community.id === 'ICAN'"> USD</ng-container>
                            <ng-container *ngIf="bootcampdelivery.nucampFlex">/month</ng-container>
                          </ng-container>
                        </b>
                        <!-- until {{bootcampdelivery.startdate | earlybirddate | nucampdate:'MMM. Do'}} -->
                      </span>
                    </div>
                    <!-- Removing the regular price from the visual -->
                    <!-- <div class="course-meta-items">
                      <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="time-outline"></ion-icon>
                      <span>
                        <b>{{(bootcampdelivery.cost.regular / bootcampdelivery.cost.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}}<ng-container *ngIf="bootcampdelivery.cost.tuitionmonths > 1">
                            <ng-container *ngIf="community && community.id === 'ICAN'"> USD</ng-container>
                            <ng-container *ngIf="!bootcampdelivery.nucampFlex">
                              <span style="font-size:10px;"> X</span>{{bootcampdelivery.cost.tuitionmonths}}
                            </ng-container>
                            <ng-container *ngIf="bootcampdelivery.nucampFlex">/month</ng-container>
                          </ng-container>
                        </b>
                        after 
                      </span>
                    </div> -->
                  </ng-container>
                  <ng-container *ngIf="bootcampdelivery.community.community.state === 'PA'">
                    <div class="course-meta-items">
                      <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="card-outline"></ion-icon>
                      <span>
                        <b>{{bootcampdelivery.cost.tuitionmonths}}</b> payments of <b>{{(bootcampdelivery.cost.regular / bootcampdelivery.cost.tuitionmonths) | currency:"USD":"symbol":"1.0-0"}}</b>
                      </span>
                    </div>
                  </ng-container>
                  <div class="course-meta-items" *ngIf="!bootcampdelivery.privatedelivery && !completeBootcampOptions">
                    <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="people"></ion-icon>
                    <span *ngIf="bootcampdelivery.spotsleft <= 0"> Bootcamp Full</span>
                    <span *ngIf="bootcampdelivery.spotsleft > 3 && bootcampdelivery.spotsleft <= 6">
                      <b> {{bootcampdelivery.spotsleft}}</b> seat<ng-container *ngIf="bootcampdelivery.spotsleft > 1">s</ng-container> left
                    </span>
                    <span *ngIf="bootcampdelivery.spotsleft > 6 && bootcampdelivery.nFollowers > 0"><b> {{bootcampdelivery.nFollowers}}</b> Interested</span>
                    <span *ngIf="nStudentRegistered(bootcampdelivery.students) < 6 && bootcampdelivery.nFollowers === 0" (click)="followBootcamp(bootcampdelivery.id)" class="href"> Interested?</span>
                    <span *ngIf="bootcampdelivery.spotsleft <= 3 && bootcampdelivery.spotsleft > 0"><b> {{bootcampdelivery.spotsleft}}</b> seat<ng-container *ngIf="bootcampdelivery.spotsleft > 1">s</ng-container> left!</span>
                  </div>
                  <div class="course-meta-items" *ngIf="bootcampdelivery.privatedelivery">
                    <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="people"></ion-icon>
                    <span> Private Delivery</span>
                  </div>
                  <div class="course-meta-items">
                    <ion-icon [color]="'nucamp-' + bootcamp.name.toLowerCase()" name="calendar-outline"></ion-icon>
                    <span>
                      {{bootcampdelivery.startdate | nucampdate:'MMM. Do'}} - {{bootcampdelivery.enddate | nucampdate:'MMM. Do'}}
                    </span>
                  </div>
                </ion-col>
                <ng-container *ngIf="!completeBootcampOptions">
                  <ion-col size="12" class="ion-text-left ion-padding-top button-register-interested2" [ngClass]="{'button-register-interested3': completeBootcampOptions}" *ngIf="bootcampdelivery.spotsleft <= 0">
                    <ion-button size="small" fill="outline" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="fullbootcamp" (click)="goToBootcampDetails(bootcampdelivery.id)">Bootcamp Full</ion-button>
                  </ion-col>
                  <ion-col size="12" class="ion-text-left ion-padding-top" *ngIf="bootcampdelivery.spotsleft > 0" >
                    <span class="bootcamp-button-padding button-square-right button-register-interested2" [ngClass]="{'button-register-interested3': completeBootcampOptions}">
                      <ion-button size="small" fill="solid" [disabled]="bootcampdelivery.privatedelivery" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="interestedbootcamp" (click)="followBootcamp(bootcampdelivery.id)"><ion-icon name="thumbs-up-sharp"></ion-icon>&nbsp;I'm Interested</ion-button>
                    </span>
                    <span class="bootcamp-button-padding button-square-left button-register-interested2" [ngClass]="{'button-register-interested3': completeBootcampOptions}">
                      <ion-button size="small" fill="solid" [color]="'nucamp-' + bootcamp.name.toLowerCase()"  data-cy="registerbootcamp" (click)="goToBootcampDetails(bootcampdelivery.id)"><ion-icon name="add-outline"></ion-icon>&nbsp;Register</ion-button>
                    </span>
                  </ion-col>
                </ng-container>
              </ion-row>
            </ion-slide>
          </ion-slides>
        </ion-col>
        <ion-col size="12" class="ion-text-center ion-padding" *ngIf="!community">
          <ng-container *ngFor="let i of [1]">
              <div class="ph-item">
                <div class="ph-col-12">
                    <div class="ph-picture"></div>
                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-4 empty big"></div>
                        <div class="ph-col-2 big"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>
                        <div class="ph-col-12"></div>
                    </div>
                </div>
            </div>
          </ng-container>
        </ion-col>
        <ion-col style="top:-25px" size="12" class="nucamp-swiper-navigation ion-no-padding">
          <ion-row class="ion-no-padding">
            <ion-col size="3.2" size-sm="5" (click)="swipePrevBootcamps()" class="ion-text-right nucamp-swiper-button-prev ion-no-padding"><fa-icon [icon]="faAngleDoubleLeft" [style]="'color: var(--ion-color-nucamp-' + bootcamp.name.toLowerCase() + ');'"></fa-icon></ion-col>
            <ion-col size="5.6" size-sm="2"></ion-col>
            <ion-col size="3.2" size-sm="5" (click)="swipeNextBootcamps()" class="ion-text-left nucamp-swiper-button-next ion-no-padding"><fa-icon [icon]="faAngleDoubleRight" [style]="'color: var(--ion-color-nucamp-' + bootcamp.name.toLowerCase() + ');'"></fa-icon></ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ng-template>

